'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrintTable = require('./components/PrintTable.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrintTable).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/print/lib/components/print-table/index.js
// module id = 1451
// module chunks = 1